// We only need to import the modules necessary for initial render
import PageLayout from '../layouts/PageLayout/PageLayout'
import Home from './Home'
import Pacientes from './Pacientes'
import Historial from './Historial'
import Perfil from './Perfil'
import Callback from './Callback'
import CallbackLayout from '../layouts/CallbackLayout/CallbackLayout'
import NotFoundLayout from '../layouts/NotFoundLayout/NotFoundLayout'
import {actions} from '../security/modules/actionsAuth'
import RecetaView from "./Cliente/routes/RecetaView";
import {PacienteLayout} from "../layouts/PacienteLayout/PacienteLayout";


function requireAuth(store) {
  return (nextState, replace, callback) => {

     let {auth} = store.getState()
     if(!auth.isAuthenticated) { //NO esta autenticado
       store.dispatch(actions.authenticationLogin())
     }
     return callback()
  }
}


/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.

    Ver https://github.com/davezuko/react-redux-starter-kit/issues/1061
    Para Callback, que no deberia mostrar el navbar ya que es aun parte del flujo
    de Autenticacion
*/

export const createRoutes = (store) => ([// now we are passing an array of routes
  {
    path        : '/',
    component   : PageLayout,
    indexRoute  : Home(store),
    onEnter: requireAuth(store),
    childRoutes : [
      {
        onEnter: requireAuth(store),
        childRoutes:[
          Pacientes(store),
          Historial(store),
          Perfil(store)
        ]
      },
    ]
  },
  {
    path: '/receta/:resourceId',
    component: PacienteLayout,
    indexRoute: RecetaView(store),
  },
  {
    path:'/callback',
    component: CallbackLayout,
    indexRoute: Callback(store)
  },
  {
    path:'*',
    component: NotFoundLayout
  }
])

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js